import Flickity from "flickity";

const feeds = new Flickity(".feeds", {
  groupCells: true,
  draggable: true,
  autoPlay: 10000,
  pageDots: true,
  prevNextButtons: false,
  wrapAround: true,
  lazyLoad: true,
});

feeds.on(
  "staticClick.flickity",
  function (event, pointer, cellElement, cellIndex) {
    if (!cellElement) {
      return;
    }
  }
);

$(".cta-feed")
  .on("click", ".arrows.prev", function () {
    feeds.previous();
    return true;
  })
  .on("click", ".arrows.next", function () {
    feeds.next();
    return true;
  });
